import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LMLocaleInitializerService } from '@services/lm-locale-initializer.service';

@NgModule({
  imports: [ CommonModule ],
  declarations: [],
  providers: [
    provideAppInitializer(() => {
      const service = inject(LMLocaleInitializerService);
      return service.initialize();
    })
  ]
})
export class LMLocaleInitializerModule {}
